import React from 'react';

import TruncateTextCmp from '../TruncateText';

interface IProps {
    label?: any;
    parentClassName?: any;
    statusLabelClassName?: string;
    dotColor?: 'primary' | 'red' | 'yellow' | 'green';
    darkTheme?: boolean;
    labelRef?: any;
    icon?: React.ReactNode;
}

const StatusDotProfileCmp = ({ label, parentClassName, dotColor, statusLabelClassName, darkTheme = false, labelRef, icon }: IProps) => (
    <div className={`flex gap-1.5 items-center ${parentClassName}`}>
        {icon
            ? icon
            : dotColor && (
                  <div
                      className={`w-3 h-3 rounded-full border-[3px] flex-none
        ${dotColor === 'primary' ? (darkTheme ? 'bg-primary border-darkIndigo' : ' bg-primary border-primary100') : ''}
        ${dotColor === 'red' ? (darkTheme ? 'bg-utilityRed400 border-darkError' : 'bg-utilityRed400 border-utilityRed100') : ''}
        ${dotColor === 'yellow' ? (darkTheme ? 'bg-warning300 border-darkYellow' : 'bg-warning300 border-warning100') : ''}
        ${dotColor === 'green' ? (darkTheme ? 'bg-successSecondary border-darkGreen' : 'bg-successSecondary border-utilitySuccess100') : ''}
        `}
                  />
              )}
        {labelRef ? (
            <TruncateTextCmp refName={labelRef} message={label}>
                <p className={`text-xs text-grayLight900 empty:hidden ${statusLabelClassName ?? ''}`} ref={labelRef}>
                    {label}
                </p>
            </TruncateTextCmp>
        ) : (
            <p className={`text-xs text-grayLight900 empty:hidden ${statusLabelClassName ?? ''}`}>{label}</p>
        )}
    </div>
);

export default StatusDotProfileCmp;
